<script lang="ts">
import AppModal from '@/components/v2/AppModal.vue';

export default {
  name: 'MultiTowerSaveModal',
  components: {
    AppModal,
  },
};
</script>

<script setup lang="ts">
import { ref, computed } from 'vue';

defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  cancel: [];
  save: [towerName: string];
}>();

const versionLabel = ref('');
const showError = ref(false);
const towerNameValid = computed(() => versionLabel.value.length > 0);

const title = 'Save Tower Visualization';
const subtitle = 'Save a read-only visualization of one or more towers that can easily be exported.'

function handleCancel() {
  emit('cancel');
  cleanup();
}

function handleAction() {
  if (!towerNameValid.value) {
    showError.value = true;
    return;
  }
  emit('save', versionLabel.value);
  cleanup();
}

function cleanup(): void {
  versionLabel.value = '';
  showError.value = false;
}

</script>

<template>
  <AppModal :show="show" :handle-cancel="handleCancel" :handle-action="handleAction">
    <template #title>
      <h1>{{ title }}</h1>
      <div class="tw:mt-3 tw:font-bold">{{ subtitle }}</div>
    </template>
    <template #content>
      <label class="tw:form-control">
        <input
          class="tw:input tw:border tw:border-solid tw:w-full"
          type="text"
          placeholder="Visual Name"
          v-model="versionLabel"
          @input="showError = false"
        />
        <div class="tw:label">
          <span class="tw:label-text-alt tw:text-primary" :class="{'tw:invisible': !showError}">Please provide a visual name.</span>
        </div>
      </label>
    </template>
  </AppModal>
</template>
